class BranchParameter {
    constructor() {
        this.id = ''
        this.branch = ''
        this.dc = ''
        this.pvd_7 = ''
        this.pvd_15 = ''
        this.pvd_30 = ''
        this.pvd_60 = ''
        this.pvd_90 = ''
        this.mdv_7 = ''
        this.mdv_15 = ''
        this.mdv_90 = ''
        this.showcase_items = ''
        this.stack_items = ''
        this.total_stock = ''
        this.coverage = ''
        this.stock = ''
        this.suggested_stock = ''
        this.considered_stock = ''
        this.considered_stock_coverage = ''
        this.price = ''
        this.cost = ''
        this.coverage_max = ''
        this.actions = []
        this.guaranteed_stock = false
        this.type_sale = ''
        this.is_favorite = false
    }

    static get fieldNames() {
        return {
            id: 'ID',
            branch: 'Loja',
            dc: 'CD',
            pvd_7: 'PVD7',
            pvd_15: 'PVD15',
            pvd_30: 'PVD30',
            pvd_60: 'PVD60',
            pvd_90: 'PVD90',
            mdv_7: 'MDV7',
            mdv_15: 'MDV15',
            mdv_90: 'MDV90',
            showcase_items: 'Most.',
            stack_items: 'Pil.',
            total_stock: 'Most. + Pil.',
            coverage: 'TC',
            stock: 'Est.',
            suggested_stock: 'Sug. Est.',
            considered_stock: 'Est. Cons.',
            considered_stock_coverage: 'TC Est.',
            price: 'Preço',
            cost: 'Custo',
            actions: 'Ações',
            guaranteed_stock: 'Estoque Garantido',
            type_sale: 'Tipo de Venda',
            is_favorite: 'Favorito'
        }
    }

    static get fieldTypes() {
        return {
            id: 'int',
            branch: 'text',
            dc: 'text',
            pvd_7: 'float',
            pvd_15: 'float',
            pvd_30: 'float',
            pvd_60: 'float',
            pvd_90: 'float',
            mdv_7: 'float',
            mdv_15: 'float',
            mdv_90: 'float',
            showcase_items: 'int',
            stack_items: 'int',
            total_stock: 'int',
            coverage: 'int',
            stock: 'int',
            suggested_stock: 'float',
            considered_stock: 'float',
            considered_stock_coverage: 'float',
            price: 'float',
            cost: 'float',
            actions: 'text',
            guaranteed_stock: 'boolean',
            type_sale: 'text',
            is_favorite: 'boolean'
        }
    }

    static get visibleFields() {
        return {
            branch: true,
            dc: true,
            pvd_7: false,
            pvd_15: false,
            pvd_30: true,
            pvd_60: true,
            pvd_90: true,
            mdv_7: false,
            mdv_15: false,
            mdv_90: true,
            showcase_items: true,
            stack_items: true,
            total_stock: true,
            coverage: true,
            stock: true,
            suggested_stock: true,
            considered_stock: true,
            considered_stock_coverage: true,
            price: true,
            cost: true,
            actions: false,
            guaranteed_stock: true,
            type_sale: true,
            is_favorite: true
        }
    }
    static get visibleFieldsDaily() {
        return {
            branch: true,
            dc: true,
            pvd_7: true,
            pvd_15: true,
            pvd_30: true,
            pvd_60: false,
            pvd_90: false,
            mdv_7: true,
            mdv_15: true,
            mdv_90: false,
            showcase_items: true,
            stack_items: true,
            total_stock: true,
            coverage: true,
            stock: true,
            suggested_stock: true,
            considered_stock: true,
            considered_stock_coverage: true,
            price: true,
            cost: true,
            actions: false,
            guaranteed_stock: true,
            type_sale: true
        }
    }

    static get editableFields() {
        return {
            simulation: true,
            ids: true,
            branch_ids: true,
            dc: true,
            mdv_90: true,
            showcase_items: true,
            stack_items: true,
            total_stock: true,
            coverage: true,
            coverage_max: true,
            stock: true,
            suggested_stock: true,
            considered_stock: true,
            price: true,
            cost: true,
            actions: true,
            guaranteed_stock: true,
            type_sale: true,
            is_favorite: false
        }
    }
}

class NewBranchParameter {
    constructor() {
        this.branch_channel = ''
        this.branch_cost = ''
        this.branch_price = ''
        this.branch_showcase_items = ''
        this.branch_stack_items = ''
        this.branch_coverage = ''
        this.branch_coverage_max = ''
        this.branch_stock_max = ''
    }

    static get fieldNames() {
        return {
            branch_channel: 'Canal',
            branch_cost: 'Custo',
            branch_price: 'Preço',
            branch_showcase_items: 'Most.',
            branch_stack_items: 'Pil.',
            branch_coverage: 'TC',
            branch_coverage_max: 'TC Máx.',
            branch_stock_max: 'Est. Máx.'
        }
    }

    static get fieldTypes() {
        return {
            branch_channel: 'select',
            branch_cost: 'text',
            branch_price: 'text',
            branch_showcase_items: 'text',
            branch_stack_items: 'text',
            branch_coverage: 'text',
            branch_coverage_max: 'text',
            branch_stock_max: 'text'
        }
    }

    static get visibleFields() {
        return {
            branch_channel: true,
            branch_cost: true,
            branch_price: true,
            branch_showcase_items: true,
            branch_stack_items: true,
            branch_coverage: true,
            branch_coverage_max: true,
            branch_stock_max: true
        }
    }

    static get editableFields() {
        return {
            branch_channel: true,
            branch_cost: true,
            branch_price: true,
            branch_showcase_items: true,
            branch_stack_items: true,
            branch_coverage: true,
            branch_coverage_max: true,
            branch_stock_max: true
        }
    }

    static get createFields() {
        return {
            branch_channel: true,
            branch_cost: true,
            branch_price: true,
            branch_showcase_items: true,
            branch_stack_items: true,
            branch_coverage: true,
            branch_coverage_max: true,
            branch_stock_max: true,
            branch_product_id: true
        }
    }
}

export default BranchParameter

export { BranchParameter, NewBranchParameter }
